import { render } from "./NoticiasComponent.vue?vue&type=template&id=1ab763c4"
import script from "./NoticiasComponent.vue?vue&type=script&lang=js"
export * from "./NoticiasComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__